import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import "./css/EnquiryPopup.css";

const EnquiryPopup = ({ destination = "", open, onClose }) => {

    const location = useLocation();
    const isTourPage = location.pathname === "/";

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [quickFormData, setQuickFormData] = useState({
        destination: destination || "",
        name: "",
        email: "",
        phone: "",
        message: "",
    });

    useEffect(() => {
        setQuickFormData(prev => ({ ...prev, destination }));
    }, [destination]);

    const handleQuickInputChange = (e) => {
        const { name, value } = e.target;
        setQuickFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleQuickSubmit = async () => {
        const { name, email, phone, destination, message } = quickFormData;

        if (!destination) return Swal.fire("Missing Field", "Please enter your destination.", "warning");
        if (!name) return Swal.fire("Missing Field", "Please enter your name.", "warning");
        if (!email) return Swal.fire("Missing Field", "Please enter your email.", "warning");
        if (!phone.trim()) return Swal.fire("Missing Field", "Please enter your phone number.", "warning");

        const phonePattern = /^\+?[0-9\s\-]{10,20}$/;
        if (!phonePattern.test(phone.trim())) return Swal.fire("Invalid Phone", "Please enter a valid phone number.", "warning");

        setIsSubmitting(true);

        try {
            const res = await axios.post("https://admin.new.plenaryholidays.com/api/HolidayPackages/quick_enquiry", {
                name, email, phone, destination, message
            });

            if (res.data.success) {
                Swal.fire("Success", res.data.message, "success");
                setQuickFormData({ destination, name: "", email: "", phone: "", message: "" });
                onClose();
            } else {
                Swal.fire("Error", res.data.message || "Submission failed", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Failed to submit query. Please try again.", "error");
        } finally {
            setIsSubmitting(false);
        }
    };

    const [showMobileModal, setShowMobileModal] = useState(false);
    const queryMobileModal = () => setShowMobileModal(!showMobileModal);

    if (!open) return null; // Desktop modal controlled by parent

    return (
        <>
            {/* Desktop Modal */}
            <div className="custom-modal-overlay" onClick={onClose}>
                <div className="modal_er" onClick={e => e.stopPropagation()}>
                    <div className="modal-content-er pd15n">
                        <div style={{ position: "relative" }}>
                            <div className="ppflex">
                                <p className="ppttl">Want to Go For A Memorable Holiday?</p>
                                <span className="close_er" onClick={onClose}>×</span>
                            </div>

                            <form id="contact">
                                <fieldset className="mflex jsb">
                                    <div className="inp_n wd48p">
                                        <input
                                            placeholder="Destination"
                                            type="text"
                                            className="txt-inp"
                                            name="destination"
                                            value={quickFormData.destination}
                                            onChange={handleQuickInputChange}
                                            required
                                        />
                                    </div>
                                </fieldset>

                                <fieldset className="mflex jsb">
                                    <div className="inp_n wd48p">
                                        <input
                                            placeholder="Your Name"
                                            type="text"
                                            className="txt-inp"
                                            name="name"
                                            value={quickFormData.name}
                                            onChange={handleQuickInputChange}
                                            required
                                        />
                                    </div>
                                </fieldset>

                                <fieldset className="jsb">
                                    <div className="inp_n wd48p">
                                        <input
                                            placeholder="Your E-mail ID"
                                            className="txt-inp1"
                                            type="email"
                                            name="email"
                                            value={quickFormData.email}
                                            onChange={handleQuickInputChange}
                                            required
                                        />
                                    </div>

                                    <div className="inp_n wd48p mflex jsb">
                                        <input
                                            placeholder="Mobile No."
                                            className="txt-inp"
                                            type="text"
                                            name="phone"
                                            value={quickFormData.phone}
                                            onChange={handleQuickInputChange}
                                            required
                                        />
                                    </div>
                                </fieldset>

                                <fieldset className="mflex jsb">
                                    <div className="inp_n wd100p">
                                        <textarea
                                            placeholder="Your Message"
                                            className="txt-inp"
                                            name="message"
                                            value={quickFormData.message}
                                            onChange={handleQuickInputChange}
                                            style={{ minHeight: "80px" }}
                                            required
                                        />
                                    </div>
                                </fieldset>

                                <fieldset>
                                    <button
                                        type="button"
                                        className="sub_qu"
                                        onClick={handleQuickSubmit}
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? <span className="spinner"></span> : "Enquire Now"}
                                    </button>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile Modal */}
            <div className="MobileModal">
                <div className={`modal_btn fancy ${showMobileModal ? 'd-none' : ''}`} id="CBtn"
                    onClick={queryMobileModal}
                >
                    <img src="https://www.freeiconspng.com/thumbs/live-chat-icon/live-chat-icon-0.png" />
                    <span>Enquire Now</span>
                </div>
                <div className={`modal_btn fancy ${showMobileModal ? 'newgrad' : 'd-none'}`} id="CBtn"
                    onClick={queryMobileModal}
                >
                    <div className="newimg">
                        <img src="https://jsak.mmtcdn.com/holidays/rn/images/6fba72c0_ic_close_fab.webp" />
                    </div>
                </div>
            </div>
            {showMobileModal && (
                <div className="BoxDetailAbove">
                    <div className="BoxDetail">
                        <a className="inbox brd" onClick={onClose}>
                            <div className="img">
                                <img src="https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Get%20a%20quote%20large.png" />
                            </div>
                            <div className="detailContent">
                                <h4 style={{ fontSize: "14px", marginBottom: "3px", fontWeight: 700, color: "#000" }}>
                                    Get a quote
                                </h4>
                                <p style={{ fontSize: "10px", marginBottom: "0px", fontWeight: 400, color: "#555454" }}>
                                    Customise your holiday to your liking
                                </p>
                            </div>
                            <div className='arrow'>
                                <img src="https://jsak.mmtcdn.com/holidays/rn/images/e24c9778_RightArrow.webp" />
                            </div>
                        </a>
                        {/* WhatsApp & Call links */}
                        <a href="https://api.whatsapp.com/send/?phone=919599408232&text=I+need+Europe+tours+packages&type=phone_number&app_absent=0" className="inbox brd">
                            <div className="img">
                                <img src="https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Get%20a%20quote%20large.png" />
                            </div>
                            <div className="detailContent">
                                <h4 style={{ fontSize: "14px", marginBottom: "3px", fontWeight: 700, color: "#000" }}>
                                    Chat with Whatsapp
                                </h4>
                                <p style={{ fontSize: "10px", marginBottom: "0px", fontWeight: 400, color: "#555454" }}>
                                    Customise your holiday to your liking
                                </p>
                            </div>
                            <div className='arrow'>
                                <img src="https://jsak.mmtcdn.com/holidays/rn/images/e24c9778_RightArrow.webp" />
                            </div>
                        </a>
                        <a href="tel:+919599408232" className="inbox">
                            <div className="img">
                                <img src="https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Get%20a%20quote%20large.png" />
                            </div>
                            <div className="detailContent">
                                <h4 style={{ fontSize: "14px", marginBottom: "3px", fontWeight: 700, color: "#000" }}>
                                    Call Us
                                </h4>
                                <p style={{ fontSize: "10px", marginBottom: "0px", fontWeight: 400, color: "#555454" }}>
                                    Our experts are just a call away
                                </p>
                            </div>
                            <div className='arrow'>
                                <img src="https://jsak.mmtcdn.com/holidays/rn/images/e24c9778_RightArrow.webp" />
                            </div>
                        </a>
                    </div>
                </div>
            )}
        </>
    );
};

export default EnquiryPopup;
